var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardVoiceSelected = function SvgIconDashboardVoiceSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M9.823 19.287a9.089 9.089 0 1 0 0-18.178 9.089 9.089 0 0 0 0 18.178Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M10.424 8.652a2.18 2.18 0 0 1 0 3.09M11.969 7.121c1.7 1.7 1.7 4.467 0 6.167"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M13.502 5.574a6.545 6.545 0 0 1 0 9.256"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F94FF",
    d: "M4.557 17.609a9.09 9.09 0 0 1-3.823-7.411c0-3.834 2.378-7.111 5.734-8.456.189 1.545-.345 2.345-.134 2.856.19.455 1.967 2.889 2.39 3.666.421.778-1.623.478-1.5 1.078.121.6.3.967-.179.967-.322 0-.866.289-1.21.489a.152.152 0 0 0 .033.277c.355.112.9.267 1.122.29.333.044.122.31.178.722.066.41.389 1.21-.078 1.31s-2.9-.31-2.922 1c-.034 1.312.41 3.212.41 3.212z"
  })));
};
export default SvgIconDashboardVoiceSelected;